export const MAIN_MENU = [
    {title:'Discover', to:'/discover',},
    {title:'Face', to:'/face',},
    {title:'Eyes', to:'/eyes',},
    {title:'Lips', to:'/lips',},
    {title:'Best Sellers', to:'/bestsellers',},
     
];